import { useState, useEffect } from "react";
import { Btn, Card, Inp, Lbl, Slct, ConfirmModal } from "../ui";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";

var SIGTE_BRAND = "#0F2C70";
var BLANK = {nombre:"",direccion:"",admin:"",horario:""};
var DIAS_SEMANA = ["Lunes","Martes","Miercoles","Jueves","Viernes","Sabado","Domingo"];

export function SigteEdificios(p) {
  var cliente = p.cliente;
  var [edificios,setEdificios]=useState([]);
  var [loading,setLoading]=useState(true);
  var [view,setView]=useState("list");
  var [editing,setEditing]=useState(null);
  var [form,setForm]=useState(BLANK);
  var [err,setErr]=useState("");
  var [confirmData,setConfirmData]=useState(null);
  var [editandoHorario,setEditandoHorario]=useState(true);
  var [diaDesde,setDiaDesde]=useState("");
  var [diaHasta,setDiaHasta]=useState("");
  var [horaDesde,setHoraDesde]=useState("");
  var [horaHasta,setHoraHasta]=useState("");

  function resetHorarioSelector(){
    setDiaDesde(""); setDiaHasta(""); setHoraDesde(""); setHoraHasta("");
  }

  function load(){
    sigteApiFetch("/edificios?cliente_id="+cliente.id).then(function(r){return r.json();}).then(function(d){
      setEdificios(d.edificios||[]); setLoading(false);
    });
  }
  useEffect(load,[cliente.id]);

  function setF(k,v){ setForm(function(f){return Object.assign({},f,{[k]:v});}); }
  function ask(msg,fn){ setConfirmData({msg:msg,fn:fn}); }

  function startNew(){ setEditing(null); setForm(BLANK); setErr(""); resetHorarioSelector(); setEditandoHorario(true); setView("edit"); }
  function startEdit(ed){
    setEditing(ed); setForm(Object.assign({},BLANK,ed)); setErr(""); resetHorarioSelector();
    setEditandoHorario(!ed.horario);
    setView("edit");
  }

  async function save(){
    if(!form.nombre.trim()){setErr("El nombre es requerido.");return;}
    var horario = form.horario;
    if(editandoHorario){
      var camposHorario = [diaDesde,diaHasta,horaDesde,horaHasta];
      var algunoLleno = camposHorario.some(function(v){return v;});
      var todosLlenos = camposHorario.every(function(v){return v;});
      if(algunoLleno && !todosLlenos){
        setErr("Completa dia desde, dia hasta, hora desde y hora hasta, o deja el horario vacio.");
        return;
      }
      horario = todosLlenos ? (diaDesde+" a "+diaHasta+" de "+horaDesde+" a "+horaHasta) : "";
    }
    var formConHorario = Object.assign({},form,{horario:horario});
    var path = editing ? "/edificios/"+editing.id : "/edificios";
    var method = editing ? "PUT" : "POST";
    var body = editing ? formConHorario : Object.assign({},formConHorario,{cliente_id:cliente.id});
    try {
      await sigteApiFetchChecked(path,{method:method,body:JSON.stringify(body)});
      setView("list"); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  function del(ed){
    ask('Eliminar "'+ed.nombre+'"? Se eliminaran tambien sus equipos.', async function(){
      try {
        await sigteApiFetchChecked("/edificios/"+ed.id,{method:"DELETE"});
        load();
      } catch(e) {
        setErr(e.message);
      }
    });
  }

  if(loading) return <p style={{color:"#64748b",fontSize:14}}>Cargando...</p>;

  return (
    <div>
      <ConfirmModal data={confirmData} onCancel={function(){setConfirmData(null);}} onConfirm={function(){if(confirmData)confirmData.fn();setConfirmData(null);}}/>
      <button onClick={p.onBack} style={{background:"none",border:"none",color:SIGTE_BRAND,fontSize:12,fontWeight:600,cursor:"pointer",padding:0,marginBottom:14}}>&larr; Volver a Clientes</button>
      {view==="list"?(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
            <div><h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:0}}>{"Edificios de "+cliente.nombre}</h1><p style={{color:"#64748b",fontSize:13,marginTop:3}}>{edificios.length+" edificios"}</p></div>
            <Btn onClick={startNew}>+ Nuevo edificio</Btn>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {edificios.map(function(ed){
              return (
                <Card key={ed.id} sx={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
                  <div style={{cursor:"pointer",flex:1}} onClick={function(){p.onOpenEdificio(ed);}}>
                    <p style={{margin:0,fontWeight:700,fontSize:14,color:"#0f172a"}}>{ed.nombre}</p>
                    <p style={{margin:"2px 0 0",fontSize:12,color:"#64748b"}}>{(ed.direccion||"Sin direccion")+" · "+(ed.admin||"Sin administrador")}</p>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={function(){p.onOpenEdificio(ed);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:SIGTE_BRAND,fontSize:12,fontWeight:600,cursor:"pointer"}}>Ver equipos</button>
                    <button onClick={function(){startEdit(ed);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:"#374151",fontSize:12,fontWeight:600,cursor:"pointer"}}>Editar</button>
                    <button onClick={function(){del(ed);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #fecaca",background:"#fef2f2",color:"#dc2626",fontSize:12,fontWeight:600,cursor:"pointer"}}>Eliminar</button>
                  </div>
                </Card>
              );
            })}
            {edificios.length===0?<p style={{color:"#94a3b8",fontSize:13}}>No hay edificios registrados.</p>:null}
          </div>
        </div>
      ):(
        <div>
          <h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:"0 0 24px"}}>{editing?"Editar edificio":"Nuevo edificio"}</h1>
          <Card>
            {err?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 16px",fontSize:13,color:"#dc2626",marginBottom:16}}>{err}</div>:null}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
              <div><Lbl c="Nombre"/><Inp value={form.nombre} onChange={function(e){setF("nombre",e.target.value);}}/></div>
              <div><Lbl c="Administrador"/><Inp value={form.admin} onChange={function(e){setF("admin",e.target.value);}}/></div>
              <div style={{gridColumn:"1 / -1"}}>
                <Lbl c="Horario"/>
                {!editandoHorario?(
                  <div>
                    <div style={{border:"1px solid #dde3f0",borderRadius:9,padding:"10px 12px",fontSize:13,color:"#374151",background:"#f8fafc"}}>{form.horario||"Sin horario"}</div>
                    <button type="button" onClick={function(){setEditandoHorario(true);}} style={{marginTop:6,background:"none",border:"none",color:SIGTE_BRAND,fontSize:12,fontWeight:600,cursor:"pointer",padding:0}}>Reemplazar horario</button>
                  </div>
                ):(
                  <div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:8}}>
                      <div>
                        <Lbl c="Dia desde"/>
                        <Slct value={diaDesde} onChange={function(e){setDiaDesde(e.target.value);}}>
                          <option value="">Selecciona...</option>
                          {DIAS_SEMANA.map(function(d){return <option key={d} value={d}>{d}</option>;})}
                        </Slct>
                      </div>
                      <div>
                        <Lbl c="Dia hasta"/>
                        <Slct value={diaHasta} onChange={function(e){setDiaHasta(e.target.value);}}>
                          <option value="">Selecciona...</option>
                          {DIAS_SEMANA.map(function(d){return <option key={d} value={d}>{d}</option>;})}
                        </Slct>
                      </div>
                      <div><Lbl c="Hora desde"/><Inp type="time" value={horaDesde} onChange={function(e){setHoraDesde(e.target.value);}}/></div>
                      <div><Lbl c="Hora hasta"/><Inp type="time" value={horaHasta} onChange={function(e){setHoraHasta(e.target.value);}}/></div>
                    </div>
                    {editing&&editing.horario?(
                      <button type="button" onClick={function(){setEditandoHorario(false); resetHorarioSelector();}} style={{background:"none",border:"none",color:"#64748b",fontSize:12,fontWeight:600,cursor:"pointer",padding:0}}>Cancelar, conservar horario anterior</button>
                    ):null}
                  </div>
                )}
              </div>
              <div style={{gridColumn:"1 / -1"}}><Lbl c="Direccion"/><Inp value={form.direccion} onChange={function(e){setF("direccion",e.target.value);}}/></div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={function(){setView("list");}} style={{flex:1,padding:"11px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
              <Btn onClick={save} sx={{flex:2,padding:"11px 0",borderRadius:9,fontSize:14}}>Guardar edificio</Btn>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
